import { supabase } from '@/integrations/supabase/client';

/**
 * auth-js turns a missing server session into AuthSessionMissingError and then
 * returns it without deleting the local token, so the next load logs you back in.
 * getUser() deletes that token when Auth reports the session is gone.
 */
export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error?.name !== 'AuthSessionMissingError') return { error };
  await supabase.auth.getUser();
  return { error: null };
}
